export default "__VITE_ASSET__BjaYhajV__"